import React, { useState } from 'react'
import {
  Sidebar,
  Option,
  Spacer,
  SmallOption,
  Toggle,
} from 'Components/DashboardSidebar'
import ArrowRefresh from 'Components/Icons/ArrowRefresh'
import LocationIcon from 'Components/Icons/Location'
import { Link } from 'react-router-dom'
import { authorization } from './../../Module/Auth/Auth'
import brandTheme from '../../Assets/Styles/brandTheme'
import { CAMPAIGN_ENUM_TYPES } from '../../shared/constants'

const { colors } = brandTheme()

const DashboardSidebar = props => {
  const { basePath, path, cityPlans, campaignType } = props

  const [sidebarOpen, setSidebarOpen] = useState(true)

  return (
    <Sidebar
      open={sidebarOpen}
      onToggle={() => setSidebarOpen(!sidebarOpen)}
      content={props.children}
    >
      <Link to={basePath + '/overview'}>
        <Option
          icon={
            <ArrowRefresh
              height={20}
              fill={path == '/overview' ? colors.primary : undefined}
            />
          }
          active={path == '/overview'}
        >
          Campaign Overview
        </Option>
      </Link>
      <Spacer />

      <Toggle
        Handle={props => (
          <Option
            icon={
              <LocationIcon
                height={20}
                fill={
                  path.startsWith('/city-plan') ? colors.primary : undefined
                }
              />
            }
            active={path.startsWith('/city-plan')}
            style={{ cursor: 'pointer' }}
            {...props}
          >
            Detailed Reports
          </Option>
        )}
        open={path.startsWith('/city-plan')}
      >
        {cityPlans
          .slice(0)
          .sort(cityPlanSort)
          .map((cityPlan, index) => (
            <Link
              key={index + '_cityPlan'}
              to={basePath + '/city-plan/' + cityPlan.id}
            >
              <SmallOption active={path == '/city-plan/' + cityPlan.id}>
                <span style={{ paddingLeft: 10 }}>{cityPlan.cityName}</span>
              </SmallOption>
            </Link>
          ))}
      </Toggle>

      {!authorization.isClient() ? (
        <Link to={basePath + '/pivot-tables'}>
          <Option active={path == '/pivot-tables'}>Pivot Tables</Option>
        </Link>
      ) : null}
      {(authorization.isClient() ||
        authorization.isAdmin() ||
        authorization.isCityManager()) &&
      campaignType === CAMPAIGN_ENUM_TYPES.DIRECTMAIL ? (
        <Link to={basePath + '/deliverability'}>
          <Option active={path == '/deliverability'}>Deliverability</Option>
        </Link>
      ) : null}
    </Sidebar>
  )
}

const cityPlanSort = function(c1, c2) {
  if (c1.cityName < c2.cityName) return -1
  if (c1.cityName > c2.cityName) return 1
  return 0
}

export default DashboardSidebar



// WEBPACK FOOTER //
// ./src/Containers/DashboardSidebar/index.js